const getSelectedQuantityValue = (selectionOptions, selectedQuantity) => {
  const optionKeys = Object.keys(selectionOptions);
  if (!optionKeys.length || !optionKeys[0]) {
    return void 0;
  }
  if (selectedQuantity === 0) {
    return { value: optionKeys[0] };
  }
  return { value: optionKeys[selectedQuantity - 1] };
};
export {
  getSelectedQuantityValue
};
//# sourceMappingURL=get-selected-quantity-value.js.map
